import { HeaderLayoutConfig } from 'ict24h-themes-react/lib/esm/components/UI/Header/Header'

export const E_OFFICE_PREFIX_URL = '/e-office'
export const configEOfficeLayout: HeaderLayoutConfig = {
  appName: ' ICT24h E-Office',
  logoLink: 'https://ict24h.net',
  backgroundColor: '#454791',
  color: '#000',
}
